import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import moment, { invalid } from "moment";
import DateTime from 'react-datetime'
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';


const SEND_NOTIFICATION = gql`
  mutation($params: EducationNotifications) {
    sendEduNotification(params: $params)
  }`

class AttendanceNotificationModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingSpinner: 0,
            currentStep: 1,
            submitError: ""
        }
    }

    handleFormSubmit = async () => {
        let params = {
            date: moment(this.props.stateData.date, 'YYYY-MM-DD').unix().toString(),
            template_name: "Daily Attendance Status",
            branch_id: this.props.stateData.branchSearchval.value.toString(),
            institute_id: parseInt(Cookies.get("institutionid")),
            notification_type: "attendance",
            section_id: parseInt(this.props.stateData.sectionSearchval.value),
            attendance_subtype_id: parseInt(this.props.stateData.attendanceSearchval.value)
        }

        this.setState({loadingSpinner: 1})

        this.sendEduNotification(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message),loadingSpinner:0 })
            setTimeout(() => {
                this.props.onHide();
            }, 3000);
        })
    }

    sendEduNotification = async params => {

        await this.props.sendEduNotification({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.sendEduNotification) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
        this.props.onsubmit()
    };

    Columns(data) {
        let Columns = [
            {
                dataField: "student_name",
                text: "Student name",
            },
            {
                dataField: "parent_mobile",
                text: "Parent mobile",
            }
        ];
        return Columns;
    }

    render() {
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
                // centered
                className="notify_modal"
            >
                {/* <Modal.Header closeButton className="notify_header">
                    <h6 className="text-center">Are you sure you want to send Notification</h6>
                </Modal.Header> */}
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">Absent Notification</Modal.Title>

                </Modal.Header>
                {
                    this.props.stateData.notifyLoader == 1 ?
                        (
                            <Container>
                                <Row>
                                    <Col sm={12}>
                                        <div className="spinner-border  text-center loading-img-center" style={{color:"#213046"}}></div>
                                    </Col >
                                </Row>
                            </Container >
                        )
                        :
                        (
                            <>
                                {
                                    this.props.stateData.getAbsentStudentsData.length > 0 ?
                                        (
                                            <>
                                                <Modal.Body className="p-1">
                                                    <CardLessDataTableWithOutSearch
                                                        parentData={this.props.stateData.getAbsentStudentsData}
                                                        particlecolumns={this.Columns()}
                                                    />
                                                </Modal.Body>

                                                <Modal.Footer variant="white" className="notify_footer">

                                                    <Row>
                                                        <Col sm={12}>
                                                            {this.state.currentStep == 5 ? (
                                                                <Form.Text className="form-text text-danger mb-2 " style={{ textAlign: "center" }}>
                                                                    Notification sent successfully
                                                                </Form.Text>
                                                            ) : (
                                                                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center", display: "none" }}>
                                                                    {this.state.submitError}
                                                                </Form.Text>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                    <Row>

                                                        <Col sm={12}>

                                                            <Button onClick={(e) => this.handleFormSubmit()} style={{backgroundColor:"#213046",border:"1px solid #213046"}} type="submit" inline>
                                                                {
                                                                    this.state.loadingSpinner == 1 ? (
                                                                        <span className="spinner-border spinner-border-sm"></span>
                                                                    ) : ""
                                                                }
                                                                SEND</Button>
                                                        </Col>

                                                    </Row>
                                                </Modal.Footer>
                                            </>
                                        )
                                        :
                                        (
                                            <h6 className="text-center p-3">No students were absent</h6>
                                        )

                                }

                            </>
                        )
                }
            </Modal>
        )
    }
}


export default withRouter(withApollo(compose(
    graphql(SEND_NOTIFICATION, {
        name: "sendEduNotification"
    })
)(AttendanceNotificationModal)));